<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <app-list-header [title]="'Application Role List'" icon="bx bx-user-pin" [$parent]="getSelf()">
            </app-list-header>
        </div>
        <div class="col-md-12 mt-3">

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 col-auto">
                            <a class="btn btn-outline-secondary btn-sm radius-30 " data-bs-toggle="modal"
                                data-bs-target="#editModal" title="Add">Add</a>
                            <!-- table form -->
                            <div class="table-responsive mb-3">
                                <table id="dataTableId" class="table table-sm table-striped my-1 ">
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Application</th>
                                            <th>Role</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let e of form['list']; let i = index">
                                            <td>{{i+1}}</td>
                                            <td>
                                                {{e["applicationName"]}}
                                            </td>
                                            <td>
                                                {{e["name"]}}
                                            </td>
                                            <td>
                                                <div class="d-flex order-actions">
                                                    <a title="Edit" data-bs-toggle="modal" data-bs-target="#editModal"
                                                        (click)="editRole(e.id)"><i class="fa fa-edit"></i></a>
                                                    <a title="Delete" class="ms-1" (click)="delete(e.id)"><i
                                                            class="fa fa-trash"></i></a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <app-list-header [$parent]="getSelf()"></app-list-header>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <form>
                                <div class="mb-2">
                                    <label for="name" class="form-label">Name</label>
                                    <div class="input-group mb-2">
                                        <input required="true" [(ngModel)]="form.data['name']" type="text"
                                            class="form-control form-control-sm" id="name" name="name"
                                            placeholder="name">
                                    </div>
                                    <span style="color:red">{{form.inputerror["name"]}} </span>
                                </div>



                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Application Role </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    title="Close"></button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="mb-2">
                        <label for="application" class="form-label">Application Role</label>
                        <div class="input-group mb-2">
                            <select #application [(ngModel)]="form.data['applicationId']"
                                class="form-select form-select-sm" id="applicationId" name="applicationId">
                                <option value="0">--Select--{{form.data['applicationId']}}</option>
                                <option *ngFor="let c of applications" value="{{c['id']}}">{{c['name']}}</option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["applicationId"]}} </span>
                    </div>

                    <div class="mb-2">
                        <label for="name" class="form-label">Name</label>
                        <div class="input-group mb-2">
                            <input required="true" [(ngModel)]="form.data['name']" type="text"
                                class="form-control form-control-sm" id="name" name="name" placeholder="name">
                        </div>
                        <span style="color:red">{{form.inputerror["name"]}} </span>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button (click)="save()" type="submit" class="btn btn-success btn-sm me-2 "><i class="fa fa-save"></i>
                    Save</button>
                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal"
                    title="Close">
                    <i class="fa fa-window-close"></i> Close
                </button>
            </div>
        </div>
    </div>
</div>